/* eslint-disable react/jsx-no-undef */
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../_config/config.const";
import { SafeTelerikReportViewer as TelerikReportViewer } from '../../_components/reporting/safe-telerik-report-viewer';
import { renderingEnd, useFixReportViewerDateFormat } from "../../_helpers/reportViewer.helper";

export function AllTicketsReportIndex() {

    useFixReportViewerDateFormat();

    let navigate = useNavigate();
    let viewer: any;

    return (
        <Box bgcolor="white" height="100%" width="98%" marginLeft="8px" marginRight="8px" borderRadius="4px">
            <TelerikReportViewer
                ref={(el: any) => viewer = el}
                serviceUrl={`${API_URL}/report/`}
                reportSource={{
                    report: 'App.Reporting.Ticket.AllTicketsReport, App.Reporting',
                }}
                viewMode="INTERACTIVE"
                scaleMode="FIT_PAGE_WIDTH"
                enableAccessibility={false}
                pageMode="CONTINUOUS_SCROLL"
                parametersAreaVisible={true}
                parametersAreaPosition="RIGHT"
            />
        </Box>

    );
}